(function (angular, window) {
    'use strict';

    /**
     * Gets the list of Services that are attached to the service type.
     */
    window.THF.Angular.API
        .factory('AddressModel', ['$http', '$q', function ($http, $q) {
            var AddressModel = function () {

            };

            /*

            string addressLine,
                int resultLimit = 10,
                string requestId = "",
                string departmentCode = ""


            api/v1/data/addresses/
            public HttpResponseMessage GetAddress(
                string recordId,
                string requestId = "",
                string departmentCode = ""
            */

            AddressModel.prototype = {
                lookup: function(addressLine) {
                    var deferred = $q.defer();
                    var req = {
                        method: 'GET',
                        url: '/api/v1/data/address-lookup?addressLine='+addressLine
                    };
                    $http(req)
                        .success(function (data) {

                            deferred.resolve(data);
                        })
                        .error(function () {
                            deferred.reject({
                                result: false,
                                message: 'No response from server',
                                content: ''
                            });
                        });
                    return deferred.promise;
                },
                retrieve: function(recordId) {
                    var deferred = $q.defer();
                    var req = {
                        method: 'GET',
                        url: '/api/v1/data/addresses/?recordId='+recordId
                    };

                    $http(req)
                        .success(function (data) {
                            deferred.resolve(data);
                        })
                        .error(function () {
                            deferred.reject({
                                result: false,
                                message: 'No response from server',
                                content: ''
                            });
                        });
                    return deferred.promise;
                }


            };

            return new AddressModel();
        }]);

})(angular, window);